import axios from 'axios';

// Prevents continually retrying (potential loop) in the event that
// the refresh token continues to be invalid.
const MAX_REFRESH_TOKEN_RETRY = 1;

const RETRY_COUNT_KEY = 'refreshTokenRetryCount';

const refreshToken = async () => {
  try {
    const response = await axios.post<{ accessToken: string }>(
      '/oauth/refresh_token',
    );

    const { accessToken } = response.data;
    sessionStorage.removeItem(RETRY_COUNT_KEY);
    return accessToken;
  } catch (err) {
    if (axios.isAxiosError(err) && err.response?.status === 401) {
      /**
       * It is possible for the refresh_token to exceed its expiry date.
       * Making a request to the auth server to re-authenticate the user
       * will assign a new refresh_token to the user and will NOT require
       * re-authentication so long as their session is stored in the auth
       * server.
       */
      const retryCount = Number(sessionStorage.getItem(RETRY_COUNT_KEY) || 0);

      if (retryCount < MAX_REFRESH_TOKEN_RETRY) {
        sessionStorage.setItem(RETRY_COUNT_KEY, `${retryCount + 1}`);
        sessionStorage.setItem('bburl', window.location.hash);

        // Force redirect
        window.location.href = `/oauth/callback`;
      }
    }

    throw err;
  }
};

export default refreshToken;
